import React from "react";
import "./Forms.css";

const forms = [
  {
    title: "Accounts Reimbursement Form",
    url: "https://accounts.iith.ac.in/forms/Reimbursement%20of%20expenditure_pdf.pdf",
  },
  {
    title: "Contingent Expenditure",
    url: "https://accounts.iith.ac.in/forms/CONTINGENT_EXPENDITURE.pdf",
  },
  {
    title: "Research Purchase Proposal Form",
    url: "https://intranet.iith.ac.in/chrome/site/files/forms/storeforms/Research_Purchase_Proposal_07_10_2025.pdf",
  },
  {
    title: "General Purchase Proposal Form",
    url: "https://intranet.iith.ac.in/chrome/site/files/forms/storeforms/general_purchase_proposal_22_jan_2026.pdf",
  },
  {
    title: "Purchase Committee Certificate Form",
    url: "https://intranet.iith.ac.in/chrome/site/files/forms/storeforms/Purchase_Committee_Certificate.pdf",
  },
];

const Forms = () => {
  return (
    <div className="forms-container">
      <h1 className="forms-header">Forms</h1>
      <div className="forms-list">
        {forms.map((form, index) => (
          <a
            key={index}
            href={form.url}
            target="_blank"
            rel="noopener noreferrer"
            className="form-card"
          >
            <div className="form-card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>
            <div className="form-card-body">
              <span className="form-card-title">{form.title}</span>
              <span className="form-card-badge">PDF</span>
            </div>
            <div className="form-card-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              <span>Download</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Forms;
